import { useState } from 'react';
import { FaHome, FaHandHoldingUsd, FaChartLine, FaSignOutAlt, FaWallet, FaUserCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

// Enhanced modal styles with bigger overlay
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '400px',
    border: 'none',
    borderRadius: '12px',
    padding: '0',
    background: 'transparent',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    backdropFilter: 'blur(5px)',
    zIndex: 1000
  }
};

const Nav = () => {
  const [isOpen, setisOpen] = useState(false);
  const navigate = useNavigate();
  
  const handleLogout = () => {
    setisOpen(true);
  }

  const confirmLogout = () => {
    // Clear all authentication data from storage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Close the modal
    setisOpen(false);
    
    // Redirect to login page
    navigate('/login');
    
    // Optional: Force a hard refresh to clear any application state
    window.location.reload();
  }

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 bg-gray-800 border-t border-gray-700 flex justify-around py-3">
        <Link to="/admin/users">
          <button className="flex flex-col items-center p-2">
            <FaHome className="text-xl" />
            <span className="text-xs mt-1">Dashboard</span>
          </button>
        </Link>
  
        {/* <Link to="/admin/users">
          <button className="flex flex-col items-center p-2">
            <FaHandHoldingUsd className="text-xl" />
            <span className="text-xs mt-1">Deposit</span>
          </button>
        </Link> */}

        {/* <Link to="/admin/users">
          <button className="flex flex-col items-center p-2">
            <FaWallet className="text-xl" />
            <span className="text-xs mt-1">Withdraw</span>
          </button>
        </Link> */}
        
        {/* <Link to="/admin/deposit_flash">
          <button className="flex flex-col items-center p-2">
            <FaUserCircle className="text-xl" />
            <span className="text-xs mt-1">Flash</span>
          </button>
        </Link> */}
        
        <button
          onClick={handleLogout}
          className="flex flex-col items-center p-2 text-gray-400"
        >
          <FaSignOutAlt className="text-xl" />
          <span className="text-xs mt-1">Logout</span>
        </button>
      </nav>

      <Modal
        isOpen={isOpen}
        style={customStyles}
        onRequestClose={() => setisOpen(false)}
        contentLabel="Logout Confirmation"
        ariaHideApp={false}
      >
        <div className="bg-gray-800 p-6 rounded-lg max-w-sm mx-auto text-white">
          <h3 className="text-xl font-semibold mb-4">Logout Confirmation</h3>
          <p className="mb-6">Are you sure you want to logout?</p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={() => setisOpen(false)}
              className="bg-gray-600 hover:bg-gray-500 py-2 px-4 rounded-lg transition"
            >
              Cancel
            </button>
            <button
              onClick={confirmLogout}
              className="bg-red-600 hover:bg-red-500 py-2 px-4 rounded-lg transition"
            >
              Logout
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Nav;